<template>
  <div :key="$i18n.locale + '_w2'">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-custom gutter-b card-stretch">
          <!--begin::Body-->
          <div class="card-body d-flex flex-column px-5">
            <template>
              <div>
                <h4>{{ $t("walletWidget.title") }}</h4>
                <span>{{ $t("walletWidget.balanceLabel") }}</span>
                <span class="float-left"
                  >{{ use_lang(formatCurrency(wallet.balance)) }}
                  {{ currencySymbol }}</span
                >
              </div>
              <div v-if="loading" class="row justify-content-center mt-10">
                <fingerprint-spinner
                  :animation-duration="1500"
                  :size="68"
                  color="#ff1d5e"
                />
              </div>

              <div v-for="item in userTransactions" :key="item.id">
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <div class="d-flex align-items-center mr-2 pt-3">
                    <i :class="getTransactionIcon(item.type)"></i>
                    <div>
                      <a
                        :key="$i18n.locale + '_' + item.id"
                        class="text-dark text-hover-primary pl-2 font-weight-bolder"
                        href="#"
                      >
                        {{
                          $t(`walletWidget.transactionTypes.${item.type}`) ||
                          $t("walletWidget.transactionTypes.default")
                        }}
                      </a>
                    </div>
                  </div>

                  <div
                    v-b-tooltip.hover
                    :title="$options.filters.timeAgo(item.created_at)"
                    class="label label-light label-inline font-weight-bold text-white bg-primary py-3 px-2"
                  >
                    {{ use_lang(formatCurrency(item.amount.$numberDecimal)) }}
                    {{ currencySymbol }}
                  </div>
                </div>
              </div>
            </template>

            <div class="row">
              <div class="col-md mt-5">
                <b-btn
                  :to="{ name: 'user.transactions' }"
                  class="btn btn-link-info mt-5"
                >
                  <i class="fa fa-eye"></i>
                  {{ $t("walletWidget.viewTransactions") }}
                </b-btn>
              </div>
              <div class="col-md-7">
                <img
                  alt=""
                  class="float-right pb-1 img-fluid"
                  src="https://cdn3d.iconscout.com/3d/premium/thumb/cash-wallet-5262966-4396852.png"
                  style="width: 126px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown2 from "@/view/content/dropdown/Dropdown2.vue";
import { mapGetters } from "vuex";
import i18n from "@/i18n";

export default {
  name: "widget-2",
  i18n,
  data() {
    return {
      userTransactions: [],
      loading: false,
      pack: [],
      expire: null,
    };
  },
  components: {
    Dropdown2,
  },
  i18n,
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getTransactionIcon(type) {
      return (
        {
          deposit: "fa fa-check fa-2x text-success",
          withdraw: "fa fa-times fa-2x text-danger",
          charge: "fa fa-check fa-2x text-success",
          refund: "fa fa-undo fa-2x text-info",
        }[type] || "fa fa-exchange-alt fa-2x text-primary"
      );
    },
    formatCurrency(value) {
      const formatter = new Intl.NumberFormat(this.$i18n.locale, {
        style: "decimal",
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
    transType(type) {
      return this.$t(
        `walletWidget.transactionTypes.${type}`,
        this.$t("walletWidget.transactionTypes.default")
      );
    },
    getUserTransactions() {
      this.loading = true;
      this.requestApiGet("newWallet/latest").then(({ data }) => {
        this.loading = false;
        this.userTransactions = data.data;
      });
    },
    getPanel() {
      this.requestApiGet("currentPack").then((response) => {
        this.pack = response.data;
        let myDate = this.pack.expired_at;
        this.fillExpire(myDate);
      });
    },
    fillExpire(expire_date) {
      if (!expire_date) {
        this.expire = "∞";
        return;
      }
      var expireDate = new Date(expire_date).getTime();
      let now = new Date().getTime();
      let diff = this.datediff(now, expireDate);
      this.expire = Math.max(
        Math.round(100 - ((this.pack.expire - diff) / this.pack.expire) * 100),
        0
      );
    },
    lastElement(i) {
      if (i === this.list.length - 1) {
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
    this.getUserTransactions();
    this.getPanel();
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapGetters("ribbon", ["new_wallet"]),
    wallet: {
      get() {
        return this.new_wallet;
      },
      set(val) {},
    },
    currencySymbol() {
      return this.$i18n.locale === "fa"
        ? "﷼"
        : this.$i18n.locale === "ar"
        ? "﷼"
        : "$";
    },
  },
};
</script>
